module.exports = __webpack_public_path__ + "static/img/5.cb173da.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/5.png
// module id = Vvc/
// module chunks = 1